import {
    ChangeDetectorRef,
    Component,
    inject,
  } from '@angular/core';
  import { FormsModule } from '@angular/forms';
  
  import { AdoptionService } from '../../services/adoption.service';
  
  @Component({
    selector: 'app-public-adoption-form',
    standalone: true,
    imports: [FormsModule],
    templateUrl: './public-adoption-form.html',
    styleUrl: './public-adoption-form.scss',
  })
  export class PublicAdoptionForm {
    private adoptionService = inject(AdoptionService);
    private cdr = inject(ChangeDetectorRef);
  
    isSubmitting = false;
    submitted = false;
  
    responsibleName = '';
    responsibleAge: number | null = null;
    responsibleGender = '';
  
    street = '';
    neighborhood = '';
    municipality = '';
  
    email = '';
    phone = '';
  
    recoveryFee: number | null = null;
  
    howDidYouHearAboutAbaq = '';
    socialNetwork = '';
    socialAccount = '';
    recommendedAbaqOnSocialMedia = false;
  
    animalPhotoUrl = '';
    animalName = '';
    species = 'DOG';
    animalGender = '';
    breed = '';
    size = '';
    animalAge: number | null = null;
    weight: number | null = null;
  
    submitForm(): void {
      if (
        !this.responsibleName ||
        !this.animalName ||
        !this.species
      ) {
        return;
      }
  
      this.isSubmitting = true;
  
      const adoption = {
        responsibleName: this.responsibleName,
        responsibleAge: this.responsibleAge,
        responsibleGender: this.responsibleGender,
  
        street: this.street,
        neighborhood: this.neighborhood,
        municipality: this.municipality,
  
        email: this.email,
        phone: this.phone,
  
        recoveryFee: this.recoveryFee ?? 0,
  
        howDidYouHearAboutAbaq:
          this.howDidYouHearAboutAbaq,
  
        socialNetwork: this.socialNetwork,
        socialAccount: this.socialAccount,
        recommendedAbaqOnSocialMedia:
          this.recommendedAbaqOnSocialMedia,
  
        animalPhotoUrl: this.animalPhotoUrl,
        animalName: this.animalName,
        species: this.species,
        animalGender: this.animalGender,
        breed: this.breed,
        size: this.size,
        animalAge: this.animalAge,
        weight: this.weight,
  
        // Estos datos pertenecen al proceso posterior
        // y no los llena la persona mediante este formulario.
        trialStartDate: undefined,
        trialComments: '',
        definitiveStartDate: undefined,
        definitiveComments: '',
        formatUrl: '',
      };
  
      this.adoptionService
        .createAdoption(adoption)
        .subscribe({
          next: (response) => {
            console.log(
              '🟢 ADOPCIÓN ENVIADA:',
              response,
            );
  
            this.isSubmitting = false;
            this.submitted = true;
  
            this.cdr.detectChanges();
          },
  
          error: (error) => {
            console.error(
              '🔴 ERROR ENVIANDO ADOPCIÓN:',
              error,
            );
  
            this.isSubmitting = false;
  
            this.cdr.detectChanges();
          },
        });
    }
  }